define('lib/objectifyForm',[], function() {
  // expects formArray as $('form').serializeArray();
  return function objectifyForm(formArray) {
    var returnObj = {};
    for (var i = 0; i < formArray.length; i++){
      returnObj[formArray[i]['name']] = formArray[i]['value'];
    }
    return returnObj;
  }
})
;
